import { render, staticRenderFns } from "./ConfirmDeleteButton.vue?vue&type=template&id=1d4f6d66"
import script from "./ConfirmDeleteButton.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports